import { WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP} from '../../../../webcomponents.constants';
import { MspInProductTrialsOverlayWindowsAppWebComponent } from './component/MspInProductTrialsOverlayWindowsAppWebComponent';

export { MspInProductTrialsOverlayWindowsAppWebComponent };

window.customElements.define(WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP, MspInProductTrialsOverlayWindowsAppWebComponent);
